export default __webpack_public_path__ + "d00ea5b40ccaec04db3c65be6f254fb3.png";